import React from 'react';
import { HEADER_RATINGS } from '../../../common/constants/data-hooks';
import { unreachable } from '../../../ts-utils';
import { useTranslate } from '../../context/api-context/translations/use-translate';
import { useApi } from '../../api-provider';
import { getIsMobile } from '../../../common/store/base-params/base-params-selectors';
import { DATA_COUNT } from '../../../common/constants/data-attributes';
import { OneStarDisplay, RatingsDisplay } from '../ratings-display';
import { classes } from './comments-header-ratings.st.css';
export const CommentsHeaderRatings = (props) => {
    const isMobile = useApi(getIsMobile);
    const t = useTranslate();
    const getRatingInfo = ({ total, average }) => {
        if (isMobile) {
            return t('header.rating-count-compact', { count: total, average });
        }
        return total === 0
            ? t('header.no-ratings-yet')
            : `${average} | ${t('header.rating-count', {
                count: total,
            })}`;
    };
    return (React.createElement("div", { className: classes.ratings, "data-hook": HEADER_RATINGS, [DATA_COUNT]: 'total' in props ? props.total : 0 }, (() => {
        switch (props.type) {
            case 'DISABLED': {
                return isMobile ? React.createElement(OneStarDisplay, null) : React.createElement(RatingsDisplay, null);
            }
            case 'ENABLED':
                return (React.createElement(React.Fragment, null,
                    isMobile ? (React.createElement(OneStarDisplay, { rating: props.average })) : (React.createElement(RatingsDisplay, { className: classes.ratingsDisplay, rating: props.average })),
                    React.createElement("div", { className: classes.ratingsInfo }, getRatingInfo({ average: props.average.toFixed(1), total: props.total }))));
            default:
                throw unreachable(props);
        }
    })()));
};
//# sourceMappingURL=comments-header-ratings.js.map